import { Moment } from 'moment';
import { DateUtils } from '../../../common/utils/DateUtils';
import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { OrganizationProfile } from '../models/OrganizationProfile';

export class OrganizationProfileMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): OrganizationProfile {
    let lastUsedDate: Moment | null = null;
    if (data.lastUsed) {
      lastUsedDate = DateUtils.toMoment(data.lastUsed);
    }
    return new OrganizationProfile(this.gqlIdEncoder.decode(data.id), data.name, data.type, data.reportCount, data.projectCount, data.preset, lastUsedDate);
  }
}
